import { useEffect, useState } from "react"
import { ButtonPrimary, ButtonStatus, IconButton } from "@nova/component-btn"
import * as Icons from "@nova/component-icons"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import {
    selectIsLocationOverrideSubmitting,
    selectLocationOverrideProjectId,
} from "features/overview/slice"
import { cancelProjectLocationOverride, submitProjectLocationOverride } from "./thunks"
import { useProjectBreadcrumbLabel } from "./useProjectBreadcrumbLabel"
import classNames from "classnames"

export const UpdateLocationHeader = () => {
    const dispatch = useAppDispatch()
    const projectId = useAppSelector(selectLocationOverrideProjectId)
    const isSubmitting = useAppSelector(selectIsLocationOverrideSubmitting)
    const breadcrumb = useProjectBreadcrumbLabel(projectId)

    const [mounted, setMounted] = useState(false)
    useEffect(() => {
        setMounted(true)
    }, [])

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Escape" && !isSubmitting) dispatch(cancelProjectLocationOverride())
        }
        document.addEventListener("keydown", handleKeyDown)
        return () => document.removeEventListener("keydown", handleKeyDown)
    }, [dispatch, isSubmitting])

    return (
        <div
            className={classNames(
                "pointer-events-auto w-full h-[74px] bg-black-800 pr-5 pl-5 flex items-center transition-transform delay-75",
                {
                    "-translate-y-full": !mounted,
                }
            )}
        >
            <div className="w-full flex items-center gap-[18px] h-6">
                <IconButton
                    onClick={() => dispatch(cancelProjectLocationOverride())}
                    disabled={isSubmitting}
                >
                    <Icons.SmallIcon
                        Icon={Icons.XClose}
                        className="text-gray-300 hover:text-gray-100"
                    />
                </IconButton>
                <div className="h-full w-px bg-gray-700" />
                <div className="flex items-center gap-2">
                    <Icons.Icon Icon={Icons.AddLocation} className="text-gray-300" />
                    <div className="text-base text-white">Update Location</div>
                </div>
                <div className="h-full w-px bg-gray-700" />
                <div className="grow shrink min-w-0 truncate text-gray-300">
                    {breadcrumb.join(" / ")}
                </div>
                <ButtonPrimary
                    title={isSubmitting ? "Placing..." : "Set Location"}
                    status={isSubmitting ? ButtonStatus.Loading : ButtonStatus.Normal}
                    preserveWidthWhileLoading
                    onClick={() => dispatch(submitProjectLocationOverride())}
                />
            </div>
        </div>
    )
}
